<template>
    <BasicModalWindow
        class="remove-ads-premium"
    >
        <template #body>
            <span class="premium-logo"></span>
            <h2>
                {{Language.say('premium.remove_ads_modal.title')}}
            </h2>
            <h3>
                {{Language.say('premium.remove_ads_modal.text')}}
            </h3>
            <LinkButton
                :link="SAPOMailConfig.server.external_links.premium"
                :text="Language.say('premium.subscribe_label')"
                class='main-action half-top-space bottom-space'
                target="_blank"
                :gtm="{
                  module : 'ads',
                  feature: 'remove_ads_modal',
                  block  : 'modal_body',
                  action : 'premium_subscribe'
                }"
            />
        </template>
    </BasicModalWindow>
</template>

<script setup>
    import BasicModalWindow         from '@/vue/Layouts/Modals/BasicModalWindow.vue';
    import LinkButton               from '@/vue/Elements/Buttons/LinkButton.vue';
    import Language                 from "@/js/Shared/Language/Language";
    import SAPOMailConfig           from "@/SAPOMailConfig";

</script>
